import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../../../../../../../../../queries/influencers';
import {
	usePagination,
	useStore,
} from '../../../../../../../../../../../utils/hooks';
import { InfluencersTable } from '../../../../../../../../../../presentational';
import { useInfluencerFilters } from '../FilterProvider';

/**
 * @description Smart component that fetches influencers based on url filters
 */
export const Table = ({ campaignId, campaign }) => {
	const { getInfluencers } = useStore();
	const { state, update } = useInfluencerFilters();
	const [getPagination] = usePagination({
		limit: state.limit || 10,
	});

	const goalReachedMap = {
		eligible: true,
		ineligible: false,
	};

	const { eligibility, ...query } = state;
	// @ts-expect-error we are ok with eligibility potentially being undefined here, but typescript is trying to warn us
	const goalReached = goalReachedMap[eligibility];

	/**
	 * update the influencer list on relevant query state changes or when data is stale
	 */
	const { isLoading, isRefetching, isError, data, error } = useQuery(
		queryKeys.list({
			campaignId,
			goalReached,
			...query,
		}),
		() =>
			getInfluencers({
				campaignId,
				goalReached,
				...query,
			}),
		{ enabled: !!campaignId, refetchOnWindowFocus: false }
	);

	/**
	 * control pagination
	 */
	const paginationConfig = {
		paginationServer: true,
		paginationDefaultPage: state.page || 1,
		paginationTotalRows: data?.influencers?.count,
		paginationPerPage: state.limit || 10,
		onChangePage: (next) => {
			const { skip, page } = getPagination({ page: next });
			update({ skip, page });
		},
		onChangeRowsPerPage: (currentRowsPerPage, page) => {
			const { skip, limit } = getPagination({
				page,
				limit: currentRowsPerPage,
			});
			update({ skip, limit });
		},
	};

	return isError ? (
		error?.message
	) : (
		<InfluencersTable
			collection={data?.influencers?.rows}
			campaign={campaign}
			progressPending={isLoading || isRefetching}
			onInfluencerSelect={() => {}}
			{...paginationConfig}
		/>
	);
};
